module.exports = __webpack_public_path__ + "static/img/12.4546483.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quartos/suite2/12.jpg
// module id = E3eq
// module chunks = 1